import React from 'react';
import { Route } from '@/navigation/Route';
import { EventCancelTicketsScreen } from './screen/EventToCancelTickets';
import { CancelTicketsScreen } from './screen/CancelTickets';

export const CANCEL_ADM_TICKETS_ROUTES = {
  eventCancelTicket: '/support/events-cancel-ticket',
  cancelTickets: '/support/cancel-ticket/:id',
};

export const CancelTicketsNavigation = (): JSX.Element => (
  <React.Fragment>
    <Route
      path={CANCEL_ADM_TICKETS_ROUTES.eventCancelTicket}
      component={EventCancelTicketsScreen}
      isPrivateRoute
    />
    <Route
      path={CANCEL_ADM_TICKETS_ROUTES.cancelTickets}
      component={CancelTicketsScreen}
      isPrivateRoute
    />
  </React.Fragment>
);
